import type { GridCustomCellProps } from "@tql/ui-components-react/kendo/grid";

import { DateCell } from "~/shared/components/trax-grid/date-cell/date-cell.tsx";
import { LoaderCell } from "~/shared/components/trax-grid/loader-cell/loader-cell.tsx";

import { useLoadCellContext } from "../../utils/load-cell-context.tsx";

/**
 * Stable module-level cell renderer for the Loads grid date columns
 * (pickup date, delivery date). Reads `isLoading` from `LoadCellContext`
 * so its function reference stays identical across renders — preventing
 * Kendo from unmounting and remounting every cell when column prefs change.
 */
export const LoadDateCell = (props: GridCustomCellProps) => {
	const { isLoading } = useLoadCellContext();
	return isLoading ? <LoaderCell {...props} /> : <DateCell {...props} />;
};
